<template>

  <div 
    id    = "tools"
    ref   = "annotation_tools"
    class = "annotation-tools elevation-2"
  >

    <ToolbarButton
      @click = "onSelectTool('ellipse');"
    >
      <v-icon :color = "tool === 'ellipse' ? 'primary' : 'default'">
        mdi-checkbox-blank-circle-outline
      </v-icon>
    </ToolbarButton>

    <ToolbarButton
      @click = "onSelectTool('rectangle');"
    >
      <v-icon :color = "tool === 'rectangle' ? 'primary' : 'default'">
        mdi-square-outline
      </v-icon>
    </ToolbarButton>

    <ToolbarButton
      @click = "onSelectTool('polygon');"
    >
      <v-icon :color="tool === 'polygon' ? 'primary' : 'default'">mdi-draw</v-icon>
    </ToolbarButton>

    <v-menu 
      attach       = "#tools"
      bottom 
      nudge-bottom  = "55px"
      nudge-right   = "80px"
    >

      <template v-slot:activator="{ on, attrs }">
        <ToolbarButton
          v-bind  = "attrs"
          v-on    = "on"
          :color  = "ui.annotationToolsColor"
        >
          <v-icon :color="pickerIconColor">mdi-palette</v-icon>
        </ToolbarButton>
      </template>

      <v-color-picker
        v-model         = "selectedColor"
        :swatches       = "colorPickerSwatches"
        style           = "{width: 100%}"
        hide-canvas
        hide-inputs
        hide-sliders
        show-swatches        
      >
      </v-color-picker>

    </v-menu>

    <v-divider 
      vertical
      class    = "mx-2"
    >
    </v-divider>

    <ToolbarButton
      @click = "onSelectTool('selection');"
    >
      <v-icon :color="tool === 'selection' ? 'primary' : 'default'">
        mdi-cursor-default
      </v-icon>
    </ToolbarButton>

    <!-- TODO Remove -->
    <ToolbarButton
      @click    = "onRemoveSelected"
      :disabled = "selectedShapeIds.length === 0"
    >
      <v-icon>
        mdi-delete
      </v-icon>
    </ToolbarButton>

    <v-divider 
      vertical
      class    = "mx-2"
    >
    </v-divider>

    <ToolbarButton
      @click = "onCloseToolbar"
    >
      <v-icon>mdi-close</v-icon>
    </ToolbarButton>

  </div>

</template>

<script>

// #region Imports

/* vuex */
import { mapState } from 'vuex';

/* Telestream */
import { 
  SET_ANNOTATION_TOOLS_ARE_SHOWN,
  SET_ANNOTATION_TOOL,
  SET_ANNOTATION_TOOLS_COLOR,
  SET_ANNOTATION_SHAPES_SELECTED
} from '@/utils/mutation-types';
import { 
  REMOVE_SHAPES_FROM_ANNOTATION
} from '@/utils/action-types';
import { COLOR_PICKER_SWATCHES } from '@/utils/constants';
import ToolbarButton from '../buttons/ToolbarButton';


// #endregion Imports

export default {

  // #region Properties

  computed: {
    ...mapState([
      'ui',
      'annotations',
      'video'
    ]),
    currentFrame() {
      return this.video.currentFrame;
    },
    colorPickerSwatches() {
      return COLOR_PICKER_SWATCHES;
    },
    tool: {
      get() {
        return this.ui.annotationTool;
      },
      set(tool) {
        this.$store.commit(SET_ANNOTATION_TOOL, tool);

        if (tool !== 'selection') {
          this.selectedShapeIds = [];
        }
      }
    },
    selectedColor: {
      get() {
        const hsl = this.ui.annotationToolsColor;

        const elements = hsl.match(/\d*\.?\d+/g);
        return {
          h: elements[0],
          s: Number(elements[1]) / 100,
          l: Number(elements[2]) / 100,
          a: 1
        };
      },
      set(color) {
        const hsl = `hsl(${color.h},${color.s * 100}%,${color.l * 100}%)`;
        this.$store.commit(SET_ANNOTATION_TOOLS_COLOR, hsl);
      }
    },
    shapes() {
      const annotations = this.annotations.annotations.filter(a => a.frame === this.currentFrame);
      let shapes = [];

      annotations.forEach(a => shapes = shapes.concat(a.shapes));

      return shapes;
    },
    selectedShapeIds: {
      get() {
        return this.ui.annotationShapesSelected;
      },
      set(shapeIds) {
        this.$store.commit(SET_ANNOTATION_SHAPES_SELECTED, shapeIds);
      }
    },
    selectedShapes() {
      return this.shapes.filter(s => this.selectedShapeIds.includes(s.id));
    },
    pickerIconColor() {
      // So the icon can be seen if the selected color is white:
      return (this.ui.annotationToolsColor === 'hsl(0,0%,100%)') ? 'secondary' : 'default';
    },
  },
  components: {
    ToolbarButton
  },

  // #endregion Properties

  // #region Methods

  methods: {

    // #region Events

    onSelectTool(tool) {
      this.tool = tool;
    },

    onCloseToolbar() {
      this.$store.commit(SET_ANNOTATION_TOOLS_ARE_SHOWN, false);
    },

    onRemoveSelected() {
      this.$store.dispatch(REMOVE_SHAPES_FROM_ANNOTATION, this.selectedShapes);
      this.selectedShapeIds = [];
    }

    // #endregion Events

  }

  // #endregion Methods

}

</script>
